export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "ASCENDING";
    SortDirection["Descending"] = "DESCENDING";
})(SortDirection || (SortDirection = {}));
